var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alert-story-maker" }, [
    _c("div", { staticClass: "modal" }, [
      _c("div", { staticClass: "header-modal" }, [
        _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("p", { staticClass: "subTitle" }, [_vm._v(_vm._s(_vm.subTitle))]),
      ]),
      _c(
        "div",
        { staticClass: "choices" },
        _vm._l(_vm.choices, function (choice) {
          return _c(
            "p",
            {
              staticClass: "choise",
              class: { red: choice.warning },
              on: { click: choice.cb },
            },
            [_vm._v(_vm._s(choice.content))]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }